module.exports = __webpack_public_path__ + "img/3.5f71f2fb.png";